import type { UnizoFeatureFlagKey } from "@shared-domain/unizo/featureFlags";
import { matchesGuideFlags } from "@/pages/Guide/guideFlags";
import type { ReleaseNote } from "./types";

/**
 * PRODUCT_DEV-1066: テナントの機能フラグに合わせて、リリースノートの項目を絞る。
 *
 * リリースノートは全テナント共通のデータで、機能の多くはテナントごとのフラグの裏にある。
 * OFF のテナントに使えない機能の告知を読ませないよう、項目の `when` で絞る（判定は使い方ガイドと同じ）。
 *
 * **項目が 1 つも残らない版は版ごと落とす。** 残すと中身の無いカードが出るうえ、
 * 未読の判定（最新の版）がその版を指して、読む物が無いのに赤ポチが付く。
 */
export const filterReleaseNotesByFlags = (
  notes: readonly ReleaseNote[],
  isOn: (key: UnizoFeatureFlagKey) => boolean,
): ReleaseNote[] =>
  notes
    .map((n) => ({
      ...n,
      highlights: n.highlights.filter((i) => matchesGuideFlags(i.when, isOn)),
      improvements: n.improvements.filter((i) => matchesGuideFlags(i.when, isOn)),
      bugfixes: n.bugfixes.filter((i) => matchesGuideFlags(i.when, isOn)),
    }))
    .filter(
      (n) => n.highlights.length + n.improvements.length + n.bugfixes.length > 0,
    );
